import {MAP_URL} from "../../constants/urls";
import {GradientColorDecoder, GradientColorInputTags} from "./forumConstant";

export function forumMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      forumId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateForumId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}

export function fixCreateForumId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function forumMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, forumId: json.result.objectId,
      conversationUrl: MAP_URL.conversationAdminPanel+json.result.conversationId+"/show",
      deepLink: MAP_URL.lunaDeepLink+json.result.conversationId,
      adsGradiantColorShow: json.result.adsGradiantColor && getGradientColor(json.result.adsGradiantColor),
      adminMarkets: json.result.markets.map((item) => ({markets : item}))
    },
  };
}

export function getGradientColor(gradient){
  return GradientColorDecoder[gradient]
}